import { Link } from 'react-router-dom';
import {
  LegalPage,
  Section, Sub, P, Table, Th, Td, Note, Ul, Ol, B, Basis,
  useLegalDocumentHead,
} from './components';

export default function PrivacyPolicy() {
  useLegalDocumentHead('개인정보처리방침 | Cupid');

  return (
    <LegalPage
      title="개인정보처리방침"
      subtitle="시행일자: 2026년 11월 2일"
      intro={
        <>
          <P>
            Cupid(이하 "회사")는 「개인정보 보호법」 등 관련 법령에 따라 이용자의 개인정보를 보호하고, 이와 관련한 고충을
            신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립합니다.
          </P>
          <P>
            본 개인정보처리방침은 이용자가 언제나 쉽게 열람할 수 있도록 회사 누리집을 통해 공개하고 있으며, 관련 법령·지침·고시
            또는 서비스 정책의 변경에 따라 달라질 수 있습니다.
          </P>
        </>
      }
    >

        {/*
          ⚠️ 본문은 완성됐으나 아직 정식 게시 상태가 아니다.
          게시 전 남은 작업:
          1. useLegalDocumentHead 두 번째 인자를 false로 바꿔 색인을 허용할 것
          2. 법률 검토 (중점 대상 — 초안 문서 6장)
          3. 선행 코드 작업 잔여 2건 — 초안 문서 5장 (2026-08-17 기준)
             - 6번: 동의 이력 저장 (앱 작업 동반)
             - 7번 잔여: 제재(sanctioned) 설정 경로 — R6-2와 통합
             완료: 탈퇴 파기(2·3·4), 11.(2) 위치 확인자료, 6.(2) DI 해시 3년,
             6.(3) 접속기록 90일. 단 DDL 2건(docs/sql/)은 운영 DB 실행 필요.
          → cupid-application-server/docs/2026_08_17_privacy-policy-draft.md
        */}

        {/*
          주요 개인정보 처리 표시(라벨링, 작성지침 Ⅴ장)는 의도적으로 넣지 않았다.
          - 법 제30조 24개 기재사항에 포함되지 않는 별도 권장사항이며, 지침도
            "마련할 수 있음", "반드시 이용하여야 하는 것은 아님"으로 규정한다(p.111).
          - 사용 시 "본문 개정 시 변경 사항이 상시 반영되도록 조치"할 의무가 붙는다(p.110).
            본문과 요약이 어긋나면 오히려 문제가 되므로, 본문이 확정된 뒤 재검토한다.
        */}

        {/* ───────────────────────────── 1 ───────────────────────────── */}
        <Section no={1} title="개인정보의 수집·이용">
          <P>
            회사는 다음과 같이 이용자의 개인정보를 수집합니다. 처리하고 있는 개인정보는 다음의 수집·이용 목적 이외의 용도로는
            활용되지 않으며, 수집·이용 목적이 변경되는 경우에는 「개인정보 보호법」에 따라 별도의 동의를 받는 등 필요한 조치를
            이행합니다.
          </P>

          <Sub>(1) 회원가입 시 (본인확인 기관을 통해 수집)</Sub>
          <Table>
            <thead><tr><Th>구분</Th><Th>수집·이용 항목</Th></tr></thead>
            <tbody>
              <tr><Td>필수</Td><Td>이름, 생년월일, 성별, 휴대전화번호, 중복가입확인정보(DI)</Td></tr>
            </tbody>
          </Table>
          <P>
            회사는 본인확인 과정에서 연계정보(CI)를 수신하나, <B>이를 저장하지 않습니다.</B> 또한 회사는{' '}
            <B>주민등록번호를 수집하지 않습니다.</B>
          </P>

          <Sub>(2) 프로필 설정 시 (이용자가 직접 입력)</Sub>
          <Table>
            <thead><tr><Th>구분</Th><Th>수집·이용 항목</Th></tr></thead>
            <tbody>
              <tr><Td>필수</Td><Td>프로필 사진</Td></tr>
              <tr><Td>선택</Td><Td>직업</Td></tr>
            </tbody>
          </Table>

          <Sub>(3) 서비스 이용 시 추가 수집</Sub>
          <Table>
            <thead><tr><Th>구분</Th><Th>수집·이용 항목</Th></tr></thead>
            <tbody>
              <tr><Td>그룹 매칭 이용 시</Td><Td>위치정보(위도·경도)</Td></tr>
              <tr><Td>채팅 이용 시</Td><Td>메시지 내용, 첨부 사진</Td></tr>
              <tr><Td>친구·그룹 기능 이용 시</Td><Td>친구 관계, 그룹 구성, 매칭 이력</Td></tr>
              <tr><Td>하트 구매 시</Td><Td>결제 플랫폼, 상품 정보, 거래 식별자, 결제 상태</Td></tr>
              <tr><Td>이용자 신고 시</Td><Td>신고 사유, 신고 상세 내용</Td></tr>
            </tbody>
          </Table>

          <Sub>(4) 서비스 이용 과정에서 자동 수집·생성</Sub>
          <Ul>
            <li>기기 식별자(Android ID 또는 IDFV)</li>
            <li>푸시 알림 토큰(FCM 토큰)</li>
            <li>최종 접속 일시</li>
            <li>앱 오류 정보(오류 내용, 기기 모델·운영체제 버전, 앱 버전, 오류 분석용 설치 식별자) — 앱 오류 발생 시에 한하며, 이용자를 식별하는 정보(이름·회원번호 등)는 포함하지 않습니다</li>
            <li>서비스 접속기록(로그기록, 접속지 정보)</li>
          </Ul>
          <P>
            회사는 <B>광고 식별자(ADID/IDFA)를 수집하지 않습니다.</B>
          </P>

          <Sub>(5) 수집 방법</Sub>
          <Ul>
            <li>본인확인 기관(NHN KCP)을 통한 본인확인 절차</li>
            <li>이용자의 앱 내 직접 입력</li>
            <li>서비스 이용 과정에서의 자동 생성 및 수집</li>
          </Ul>

          <Sub>(6) 수집한 개인정보의 이용 목적</Sub>
          <Ul>
            <li>회원 가입 의사 확인, 본인확인, 만 19세 이상 여부 확인, 중복 가입 방지</li>
            <li>회원 식별 및 관리, 단말 1대 로그인 관리</li>
            <li>그룹 구성, 위치 기반 그룹 매칭, 채팅, 친구 관리 등 서비스 제공</li>
            <li>매칭·채팅·친구 요청 등 서비스 알림 발송</li>
            <li>하트 인앱결제 처리 및 결제 검증, 결제 이력 관리</li>
            <li>부적절한 프로필 사진 차단, 이용자 신고 접수 및 처리, 부정이용 방지, 분쟁 대응</li>
            <li>고지사항 전달, 민원처리 및 고객상담</li>
          </Ul>
          <Basis>
            「개인정보 보호법」 제15조 제1항 제1호(동의), 제4호(계약의 이행), 제6호(정당한 이익)
          </Basis>
        </Section>

        {/* ───────────────────────────── 2 ───────────────────────────── */}
        <Section no={2} title="개인정보의 제3자 제공">
          <P>
            <B>회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다.</B> 다만 다음의 경우는 예외로 합니다.
          </P>
          <Ol>
            <li>이용자가 사전에 동의한 경우</li>
            <li>법령의 규정에 의하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
          </Ol>
          <Note>
            <B>참고.</B> 서비스 이용 과정에서 다른 이용자에게 프로필 정보(이름, 나이, 성별, 직업, 프로필 사진)가 표시되는 것은
            서비스의 본질적 기능이며, 제3자 제공에 해당하지 않습니다. 이용자는 그룹 매칭 시 상대 그룹 구성원에게 위 정보가
            표시된다는 점을 인지하고 서비스를 이용하시기 바랍니다.
          </Note>
        </Section>

        {/* ───────────────────────────── 3 ───────────────────────────── */}
        <Section no={3} title="개인정보의 추가적인 이용 또는 제공">
          <P>
            회사는 「개인정보 보호법」 제15조 제3항 또는 제17조 제4항에 따라 아래 사항을 종합적으로 고려하여 당초 수집 목적과
            합리적으로 관련된 범위에서 이용자의 동의 없이 개인정보를 추가적으로 이용 또는 제공할 수 있습니다.
          </P>
          <Ul>
            <li>추가적으로 이용 또는 제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부</li>
            <li>개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용 또는 제공에 대한 예측 가능성이 있는지 여부</li>
            <li>이용자의 이익을 부당하게 침해하는지 여부</li>
            <li>가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</li>
          </Ul>
        </Section>

        {/* ───────────────────────────── 4 ───────────────────────────── */}
        <Section no={4} title="개인정보의 처리위탁">
          <P>
            회사는 원활하고 향상된 서비스를 제공하기 위해 개인정보 처리 업무를 위탁하고 있습니다. 위탁 시 이용자의 개인정보가
            안전하게 처리될 수 있도록 관리·감독하며, 수탁업체가 위탁 업무 범위를 넘어 개인정보를 처리하지 않도록 제한합니다.
          </P>
          <Table>
            <thead><tr><Th>수탁업체</Th><Th>위탁 업무</Th><Th>위탁 항목</Th></tr></thead>
            <tbody>
              <tr><Td>NHN KCP</Td><Td>본인확인</Td><Td>이름, 생년월일, 성별, 휴대전화번호</Td></tr>
              <tr><Td>Google LLC</Td><Td>푸시 알림 발송</Td><Td>푸시 알림 토큰, 알림 제목 및 내용</Td></tr>
              <tr><Td>Google LLC</Td><Td>프로필 사진 유해성 검사</Td><Td>프로필 사진</Td></tr>
              <tr><Td>Google LLC</Td><Td>앱 오류 분석(Firebase Crashlytics)</Td><Td>앱 오류 정보(오류 내용, 기기 모델·운영체제 버전, 앱 버전, 오류 분석용 설치 식별자)</Td></tr>
              <tr><Td>Apple Inc.</Td><Td>인앱결제 검증(iOS)</Td><Td>결제 거래 식별자, 상품 정보</Td></tr>
              <tr><Td>Google LLC</Td><Td>인앱결제 검증(Android)</Td><Td>결제 거래 식별자(구매 토큰), 상품 정보</Td></tr>
            </tbody>
          </Table>
          <Basis>「개인정보 보호법」 제26조(업무위탁에 따른 개인정보의 처리 제한)</Basis>
        </Section>

        {/* ───────────────────────────── 5 ───────────────────────────── */}
        <Section no={5} title="개인정보의 국외 이전">
          <P>
            회사는 아래와 같이 개인정보를 국외로 이전하고 있습니다. 국외로 이전되는 개인정보는 안전성 확보 조치, 개인정보
            침해에 대한 고충처리 및 분쟁해결에 관한 조치 등 보호조치를 계약 내용에 반영하여 회사의 관리·감독하에 안전하게
            처리됩니다.
          </P>
          <P>
            <B>이용자는 개인정보의 국외 이전을 거부할 수 있습니다.</B> 다만 이 경우 푸시 알림 수신, 프로필 사진 등록, 하트 구매
            등 해당 기능의 이용이 제한됩니다. 이전을 원하지 않는 경우 앱 내 프로필 화면에서 회원 탈퇴를 하실 수 있습니다.
          </P>
          <Basis>「개인정보 보호법」 제26조, 제28조의8 제1항 제3호(처리위탁·보관)</Basis>

          <Table>
            <thead><tr><Th>구분</Th><Th>내용</Th></tr></thead>
            <tbody>
              <tr><Td>수탁업체(이전받는 자)</Td><Td>Google LLC (googlekrsupport@google.com)</Td></tr>
              <tr><Td>이전되는 국가</Td><Td>미국</Td></tr>
              <tr><Td>이전되는 개인정보 항목</Td><Td>푸시 알림 토큰, 알림 제목 및 내용<br /><B>(발신자 이름 및 메시지 내용이 포함될 수 있음)</B></Td></tr>
              <tr><Td>이전 목적</Td><Td>푸시 알림 발송</Td></tr>
              <tr><Td>이전 일시 및 방법</Td><Td>알림 발생 시 안전한 네트워크를 통한 실시간 전송</Td></tr>
              <tr><Td>보유 및 이용기간</Td><Td>발송 목적 달성 시까지</Td></tr>
            </tbody>
          </Table>

          <Table>
            <thead><tr><Th>구분</Th><Th>내용</Th></tr></thead>
            <tbody>
              <tr><Td>수탁업체(이전받는 자)</Td><Td>Google LLC (googlekrsupport@google.com)</Td></tr>
              <tr><Td>이전되는 국가</Td><Td>미국</Td></tr>
              <tr><Td>이전되는 개인정보 항목</Td><Td>프로필 사진</Td></tr>
              <tr><Td>이전 목적</Td><Td>부적절한 사진 차단을 위한 유해성 검사</Td></tr>
              <tr><Td>이전 일시 및 방법</Td><Td>프로필 사진 등록 시 안전한 네트워크를 통한 실시간 전송</Td></tr>
              <tr><Td>보유 및 이용기간</Td><Td>검사 완료 후 즉시 파기</Td></tr>
            </tbody>
          </Table>

          <Table>
            <thead><tr><Th>구분</Th><Th>내용</Th></tr></thead>
            <tbody>
              <tr><Td>수탁업체(이전받는 자)</Td><Td>Apple Inc. (apple.com/legal/privacy/contact)</Td></tr>
              <tr><Td>이전되는 국가</Td><Td>미국</Td></tr>
              <tr><Td>이전되는 개인정보 항목</Td><Td>결제 거래 식별자, 상품 정보</Td></tr>
              <tr><Td>이전 목적</Td><Td>인앱결제 검증(iOS)</Td></tr>
              <tr><Td>이전 일시 및 방법</Td><Td>결제 발생 시 안전한 네트워크를 통한 실시간 전송</Td></tr>
              <tr><Td>보유 및 이용기간</Td><Td>검증 완료 시까지</Td></tr>
            </tbody>
          </Table>

          <Table>
            <thead><tr><Th>구분</Th><Th>내용</Th></tr></thead>
            <tbody>
              <tr><Td>수탁업체(이전받는 자)</Td><Td>Google LLC (googlekrsupport@google.com)</Td></tr>
              <tr><Td>이전되는 국가</Td><Td>미국</Td></tr>
              <tr><Td>이전되는 개인정보 항목</Td><Td>결제 거래 식별자(구매 토큰), 상품 정보</Td></tr>
              <tr><Td>이전 목적</Td><Td>인앱결제 검증(Android)</Td></tr>
              <tr><Td>이전 일시 및 방법</Td><Td>결제 발생 시 안전한 네트워크를 통한 실시간 전송</Td></tr>
              <tr><Td>보유 및 이용기간</Td><Td>검증 완료 시까지</Td></tr>
            </tbody>
          </Table>

          <Table>
            <thead><tr><Th>구분</Th><Th>내용</Th></tr></thead>
            <tbody>
              <tr><Td>수탁업체(이전받는 자)</Td><Td>Google LLC (googlekrsupport@google.com)</Td></tr>
              <tr><Td>이전되는 국가</Td><Td>미국</Td></tr>
              <tr><Td>이전되는 개인정보 항목</Td><Td>앱 오류 정보(오류 내용, 기기 모델·운영체제 버전, 앱 버전, 오류 분석용 설치 식별자)</Td></tr>
              <tr><Td>이전 목적</Td><Td>앱 오류 분석 및 서비스 안정성 개선(Firebase Crashlytics)</Td></tr>
              <tr><Td>이전 일시 및 방법</Td><Td>앱 오류 발생 시 안전한 네트워크를 통한 전송</Td></tr>
              <tr><Td>보유 및 이용기간</Td><Td>수집일로부터 90일</Td></tr>
            </tbody>
          </Table>

          <Note>
            <B>푸시 알림 관련 안내.</B> 채팅 알림에는 발신자의 이름과 메시지 내용 일부가 포함되어 전송됩니다. 이는 알림만으로
            내용을 확인할 수 있도록 하기 위함입니다. 알림 수신을 원하지 않는 경우 기기의 앱 설정에서 알림 권한을 해제할 수
            있습니다.
          </Note>
        </Section>

        {/* ───────────────────────────── 6 ───────────────────────────── */}
        <Section no={6} title="개인정보의 보유 및 이용기간">
          <P>
            회사는 원칙적으로 <B>회원 탈퇴 시 개인정보를 지체 없이 파기</B>합니다. 다만 다음의 경우 해당 기간 동안 보관합니다.
          </P>

          <Sub>(1) 다른 이용자의 이용 기록 보호를 위한 보관</Sub>
          <Table>
            <thead><tr><Th>항목</Th><Th>보관 내용</Th><Th>사유</Th></tr></thead>
            <tbody>
              <tr>
                <Td>채팅 메시지</Td>
                <Td>메시지 내용 및 전송 일시 (발신자 표시는 "탈퇴한 사용자"로 대체)</Td>
                <Td>대화 상대방의 기록 보호. 탈퇴 회원 1인의 요청으로 상대방의 대화 기록을 삭제할 수 없음</Td>
              </tr>
            </tbody>
          </Table>

          <Sub>(2) 계약 이행 및 정당한 이익을 위한 보관</Sub>
          <Table>
            <thead><tr><Th>보유 목적</Th><Th>보유 항목</Th><Th>보유 기간</Th></tr></thead>
            <tbody>
              <tr>
                <Td>이용자 신고 처리 및 분쟁 대응</Td>
                <Td>신고 접수·처리 내역</Td>
                <Td>회원 탈퇴일로부터 3년</Td>
              </tr>
              <tr>
                <Td>신고·제재 회피를 위한 재가입 방지</Td>
                <Td>중복가입확인정보(DI)의 일방향 암호화 값</Td>
                <Td>회원 탈퇴일로부터 3년</Td>
              </tr>
            </tbody>
          </Table>
          <Note>
            <B>재가입 방지 목적 보관에 관한 안내.</B> 회사는 다른 이용자의 안전을 위해, 신고를 받아 이용이 제한된 이용자가
            탈퇴 후 재가입하여 서비스에 다시 진입하는 것을 방지하고 있습니다. 이 목적으로 <B>중복가입확인정보(DI)를 복원할 수
            없도록 일방향 암호화한 값만</B> 보관하며, 이름·휴대전화번호 등 다른 개인정보는 보관하지 않습니다. 보관 기간은 신고
            내역 보유기간과 동일하게 3년으로 하며, 재가입 여부 확인 외의 목적으로는 이용하지 않습니다.
          </Note>
          <Basis>「개인정보 보호법」 제15조 제1항 제4호(계약의 이행), 제6호(정당한 이익)</Basis>

          <Sub>(3) 관계 법령에 따른 보관</Sub>
          <Table>
            <thead><tr><Th>법령</Th><Th>대상</Th><Th>보유 기간</Th></tr></thead>
            <tbody>
              <tr>
                <Td>통신비밀보호법 제15조의2 제2항</Td>
                <Td>서비스 접속기록(로그기록, 접속지 정보 등)</Td>
                <Td>3개월</Td>
              </tr>
              <tr>
                <Td rowSpan={3}>전자상거래 등에서의 소비자보호에 관한 법률 시행령 제6조 제1항</Td>
                <Td>대금결제 및 재화 등의 공급에 관한 기록</Td>
                <Td>5년</Td>
              </tr>
              <tr><Td>계약 또는 청약철회 등에 관한 기록</Td><Td>5년</Td></tr>
              <tr><Td>소비자의 불만 또는 분쟁처리에 관한 기록</Td><Td>3년</Td></tr>
            </tbody>
          </Table>

          {/*
            장기 미이용(휴면) 조항은 의도적으로 넣지 않았다.
            - 법 제30조 24개 기재사항에 없다. 작성지침은 "휴면고객 정책 운영"을 23번
              자율 기재사항의 예시(ISMS-P 인증·영향평가와 같은 층위)로만 언급한다(p.83).
              과거 정보통신망법의 개인정보 유효기간제(1년)는 폐지되어 현재 법정 의무가 아니다.
            - 3사 중 네이버는 휴면 조항이 없고, 배민만 2년(이용약관 근거)이다.
            - Cupid는 하트 잔액이 있어, 미이용을 사유로 계정을 파기하면 이용자가 결제한
              하트가 사라져 소비자 분쟁 소지가 있다.
            - 방치 프로필로 인한 매칭 품질 저하는 개인정보 파기가 아니라 lastSeenAt 기반
              매칭 후보 제외로 해결한다(계정을 지우지 않으므로 하트 분쟁 없음).
            휴면 정책을 실제로 운영하기로 결정하면 그때 추가한다.
          */}
        </Section>

        {/* ───────────────────────────── 7 ───────────────────────────── */}
        <Section no={7} title="개인정보의 파기 절차 및 방법">
          <Sub>(1) 파기 절차</Sub>
          <P>
            회사는 파기 사유가 발생한 개인정보를 개인정보 보호책임자의 승인 절차를 거쳐 파기합니다. 보유·이용기간이 경과하거나
            처리목적이 달성되었음에도 다른 법령에 따라 계속 보존하여야 하는 경우에는 해당 개인정보를 별도의
            데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
          </P>

          <Sub>(2) 파기 방법</Sub>
          <Ul>
            <li>전자적 파일 형태로 기록·저장된 개인정보: 기록을 재생할 수 없도록 기술적·물리적 방법을 이용하여 파기</li>
            <li>종이에 출력된 개인정보: 분쇄기로 분쇄하거나 소각</li>
          </Ul>

          <Sub>(3) 회원 탈퇴 시 처리 내역</Sub>
          <Table>
            <thead><tr><Th>항목</Th><Th>처리</Th></tr></thead>
            <tbody>
              <tr><Td>이름, 휴대전화번호, 기기 식별자, 푸시 알림 토큰</Td><Td>삭제 또는 복원 불가능하게 대체</Td></tr>
              <tr><Td>프로필 사진</Td><Td>저장 파일 삭제</Td></tr>
              <tr><Td>생년월일, 성별, 직업</Td><Td>삭제</Td></tr>
              <tr><Td>친구 관계, 그룹 참여 정보, 위치정보</Td><Td>삭제</Td></tr>
              <tr><Td>중복가입확인정보(DI)</Td><Td>원본 삭제. 재가입 방지 목적의 일방향 암호화 값만 3년 보관 (6.(2))</Td></tr>
              <tr><Td>채팅 메시지</Td><Td>발신자 표시를 "탈퇴한 사용자"로 대체 (6.(1))</Td></tr>
              <tr><Td>신고 내역, 결제 내역</Td><Td>6.(2)·(3)의 기간 동안 보관 후 파기</Td></tr>
            </tbody>
          </Table>
        </Section>

        {/* ───────────────────────────── 8 ───────────────────────────── */}
        <Section no={8} title="이용자 및 법정대리인의 권리와 그 행사방법">
          <P>이용자는 언제든지 다음의 권리를 행사할 수 있습니다.</P>
          <Ol>
            <li>개인정보 열람 요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제 요구</li>
            <li>처리정지 요구</li>
            <li>동의 철회</li>
          </Ol>

          <Sub>권리 행사 방법</Sub>
          <Table>
            <thead><tr><Th>권리</Th><Th>경로</Th></tr></thead>
            <tbody>
              <tr><Td>열람·정정</Td><Td>앱 내 프로필 화면에서 등록 정보 확인 및 수정</Td></tr>
              <tr><Td>삭제(탈퇴)</Td><Td>앱 내 프로필 화면 → 회원 탈퇴</Td></tr>
              <tr><Td>웹을 통한 삭제 요청</Td><Td><Link to="/account-deletion" className="text-red-400 hover:text-red-300">계정 및 데이터 삭제 안내</Link></Td></tr>
              <tr><Td>그 외</Td><Td>13.의 개인정보 보호책임자에게 전자우편으로 요청</Td></tr>
            </tbody>
          </Table>
          <P>
            권리 행사는 「개인정보 보호법 시행령」 제41조 제1항에 따라 서면, 전자우편 등을 통하여 하실 수 있으며, 회사는 이에
            대해 지체 없이 조치하겠습니다. 권리 행사는 이용자의 법정대리인이나 위임을 받은 대리인을 통하여 하실 수도 있습니다.
          </P>
          <P>
            이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용하거나 제공하지
            않습니다.
          </P>
          <P>
            회사는 다음에 해당하는 경우 개인정보의 열람·정정·삭제·처리정지 등을 거절할 수 있으며, 이용자의 권리는{' '}
            「개인정보 보호법」 제35조 제4항 및 제37조 제2항에 의하여 제한될 수 있습니다.
          </P>
          <Ol>
            <li>법률에 따라 열람·정정·삭제·처리정지 등이 금지되거나 제한되는 경우</li>
            <li>다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
          </Ol>
          <P>
            이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 타인의 개인정보를 도용한 회원가입의 경우 이용자 자격을
            상실하거나 관련 법령에 의해 처벌받을 수 있습니다.
          </P>
        </Section>

        {/* ───────────────────────────── 9 ───────────────────────────── */}
        <Section no={9} title="개인정보 자동수집장치의 설치·운영 및 그 거부">
          <P>
            회사의 서비스는 모바일 애플리케이션으로 제공되며, <B>쿠키를 사용하지 않습니다.</B>
          </P>
          <P>
            서비스는 이용자 식별 및 알림 발송을 위해 기기 식별자와 푸시 알림 토큰을 수집합니다. 이용자는 기기의 앱 설정에서 알림
            권한을 해제하여 푸시 알림 토큰의 수집·이용을 거부할 수 있으며, 이 경우 서비스 알림을 받을 수 없습니다.
          </P>
          <P>
            회사는{' '}
            <B>광고 목적의 식별자를 수집하지 않으며, 이용자의 행태정보를 수집·분석하는 도구를 사용하지 않습니다. 맞춤형 광고를 제공하지 않습니다.</B>
          </P>
        </Section>

        {/* ───────────────────────────── 10 ───────────────────────────── */}
        <Section no={10} title="개인정보의 안전성 확보조치">
          <P>
            회사는 이용자의 개인정보가 분실·도난·유출·변조·훼손되지 않도록 다음과 같이 안전성 확보조치를 취하고 있습니다.
          </P>
          <Sub>(1) 중요 개인정보의 암호화</Sub>
          <P>회사는 법령에서 정한 주요 개인정보를 안전한 암호 알고리즘으로 암호화하여 저장하고 있습니다.</P>
          <Sub>(2) 전송 구간 보호</Sub>
          <P>개인정보는 HTTPS/WSS 등 암호화된 통신 구간을 통해 전송되며, 인증 토큰 기반 접근 통제를 적용합니다.</P>
          <Sub>(3) 해킹 등에 대비한 대책</Sub>
          <P>
            침입차단 시스템을 운영하여 외부로부터의 무단 접근을 통제하고 있으며, 데이터베이스 및 저장소에 대한 접근 권한을
            제한하고 있습니다.
          </P>
          <Sub>(4) 개인정보 처리 최소화 및 교육</Sub>
          <P>
            개인정보를 취급하는 담당자를 최소한으로 제한하며, 담당자에 대한 교육을 통해 법령 및 내부방침의 준수를 강조하고
            있습니다.
          </P>
          <Sub>(5) 물리적 조치</Sub>
          <P>서버가 위치한 시설에 대한 접근을 통제하고 있습니다.</P>
        </Section>

        {/* ───────────────────────────── 11 ───────────────────────────── */}
        <Section no={11} title="개인위치정보의 처리">
          <P>
            회사는 「위치정보의 보호 및 이용 등에 관한 법률」(이하 "위치정보법")에 따라 이용자의 개인위치정보를 안전하게
            관리합니다. 이에 관한 세부 사항은{' '}
            <Link to="/location-terms" className="text-red-400 hover:text-red-300">「위치기반서비스 이용약관」</Link>에서 정합니다.
          </P>

          <Sub>(1) 개인위치정보의 처리목적 및 보유기간</Sub>
          <P>
            회사는 <B>이용자가 매칭 기능을 직접 시작한 시점에만</B> 개인위치정보를 수집하며, 반경 5km 이내의 상대 그룹을 찾는
            목적으로만 이용합니다. 앱을 사용하지 않는 동안에는 위치를 추적하지 않습니다. 매칭이 종료·중단되면 개인위치정보를
            즉시 파기하며, 다른 이용자에게 정확한 위치나 좌표는 공개되지 않습니다.
          </P>

          <Sub>(2) 개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간</Sub>
          <P>
            회사는 위치정보법 제16조 제2항에 근거하여 민원처리 등을 위한 위치정보 수집·이용·제공사실 확인자료를 위치정보
            시스템에 자동으로 기록·보존하며, 해당 자료는 <B>6개월간</B> 보관합니다.
          </P>
          <Basis>「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항</Basis>

          <Sub>(3) 개인위치정보의 파기 절차 및 방법</Sub>
          <P>
            회사는 보유·이용기간의 경과, 처리목적 달성 등 개인위치정보가 불필요하게 되었을 때에는 지체 없이 파기합니다. 전자적
            파일 형태로 기록·저장된 개인위치정보는 기록을 재생할 수 없도록 기술적 방법을 이용하여 파기합니다.
          </P>

          <Sub>(4) 개인위치정보의 제3자 제공 및 통보에 관한 사항</Sub>
          <P>
            회사는 <B>이용자의 사전 동의 없이 개인위치정보를 제3자에게 제공하지 않습니다.</B> 만일 이용자가 지정한 제3자에게
            개인위치정보를 제공하는 경우에는 매회 이용자에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.
          </P>

          <Sub>(5) 위치정보 관리책임자</Sub>
          <P>
            회사의 위치정보 관리책임자는 개인정보 보호책임자가 겸직하고 있습니다. 개인위치정보의 보호업무 및 관련 고충사항을
            처리하는 부서의 명칭과 연락처는 13.에 기재된 정보와 동일합니다.
          </P>

          <Sub>(6) 8세 이하의 아동 등의 보호의무자 권리·의무 및 행사방법</Sub>
          <P>
            본 서비스는 <B>만 19세 이상만 이용할 수 있으므로</B> 8세 이하의 아동 등이 이용자가 되는 경우는 없습니다. 다만
            위치정보법에 따른 안내를 위해 관련 내용을 기재합니다.
          </P>
          <P>
            위치정보법에 따라 8세 이하의 아동, 피성년후견인, 「장애인복지법」 제2조 제2항 제2호에 따른 정신적 장애를 가진
            사람으로서 「장애인고용촉진 및 직업재활법」 제2조 제2호에 따른 중증장애인에 해당하는 사람(「장애인복지법」 제32조에
            따라 장애인 등록을 한 사람만 해당)의 보호의무자가 그 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에
            동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
          </P>
        </Section>

        {/* ───────────────────────────── 12 ───────────────────────────── */}
        <Section no={12} title="처리하지 않는 개인정보">
          <P>회사는 다음 각 호의 개인정보를 처리하지 않습니다.</P>
          <Ol>
            <li>본 서비스는 만 19세 이상만 이용 가능하므로, <B>14세 미만 아동의 개인정보</B>를 처리하지 않습니다.</li>
            <li><B>민감정보</B>(사상·신념, 노동조합·정당의 가입·탈퇴, 정치적 견해, 건강, 성생활 등에 관한 정보, 유전정보, 범죄경력자료)를 처리하지 않습니다.</li>
            <li><B>고유식별정보</B>(주민등록번호, 여권번호, 운전면허번호, 외국인등록번호)를 처리하지 않습니다.</li>
            <li><B>가명정보</B>를 처리하지 않습니다.</li>
            <li>제3자가 <B>행태정보</B>를 수집하도록 허용하지 않으며, 맞춤형 광고를 제공하지 않습니다.</li>
            <li><B>고정형·이동형 영상정보처리기기</B>를 설치·운영하지 않습니다.</li>
          </Ol>
        </Section>

        {/* ───────────────────────────── 13 ───────────────────────────── */}
        <Section no={13} title="개인정보 보호책임자 및 담당부서">
          <P>
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제를 위하여
            아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </P>
          <Table>
            <thead><tr><Th colSpan={2}>개인정보 보호책임자</Th></tr></thead>
            <tbody>
              <tr><Td>성명</Td><Td>정지성</Td></tr>
              <tr><Td>직책</Td><Td>대표</Td></tr>
              <tr><Td>연락처</Td><Td><a className="text-red-400 hover:text-red-300" href="tel:010-4027-8182">010-4027-8182</a></Td></tr>
              <tr>
                <Td>전자우편</Td>
                <Td><a className="text-red-400 hover:text-red-300" href="mailto:support@cupidlab.io">support@cupidlab.io</a></Td>
              </tr>
            </tbody>
          </Table>
          <P>
            이용자는 서비스 이용 중 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 위 연락처로
            문의하실 수 있습니다. 개인정보의 열람청구도 위 연락처로 접수하실 수 있으며, 회사는 지체 없이 답변 및 처리하겠습니다.
          </P>
        </Section>

        {/* ───────────────────────────── 14 ───────────────────────────── */}
        <Section no={14} title="개인정보 침해에 대한 신고 및 상담">
          <P>
            이용자는 개인정보 침해에 대한 피해구제·상담 등을 아래 기관에 문의하실 수 있습니다. 아래 기관은 정부기관 소속으로서,
            회사의 자체적인 불만처리 또는 피해구제 결과에 만족하지 못하시거나 자세한 도움이 필요한 경우 문의하여 주시기
            바랍니다.
          </P>
          <Table>
            <thead><tr><Th>기관</Th><Th>전화번호</Th><Th>홈페이지</Th></tr></thead>
            <tbody>
              <tr><Td>개인정보침해신고센터</Td><Td>(국번없이) 118</Td><Td>privacy.kisa.or.kr</Td></tr>
              <tr><Td>개인정보분쟁조정위원회</Td><Td>1833-6972</Td><Td>www.kopico.go.kr</Td></tr>
              <tr><Td>대검찰청 사이버수사과</Td><Td>(국번없이) 1301</Td><Td>www.spo.go.kr</Td></tr>
              <tr><Td>경찰청 사이버범죄 신고시스템</Td><Td>(국번없이) 182</Td><Td>ecrm.police.go.kr</Td></tr>
            </tbody>
          </Table>
        </Section>

        {/* ───────────────────────────── 15 ───────────────────────────── */}
        <Section no={15} title="고지의 의무">
          <P>
            본 개인정보처리방침은 법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 수 있으며, 변경 시에는
            시행 <B>7일 전</B>부터 앱 내 공지사항 또는 본 페이지를 통하여 고지합니다. 다만 이용자 권리의 중요한 변경이 있을
            경우에는 최소 <B>30일 전</B>에 고지합니다.
          </P>
          <P>변경 전의 개인정보처리방침은 아래에서 확인하실 수 있습니다.</P>
          <Ul>
            <li>공고일자: 2026년 11월 2일</li>
            <li>시행일자: 2026년 11월 2일</li>
          </Ul>
          <Sub>개정 이력</Sub>
          <Ul>
            <li>2026년 11월 2일: 채팅 첨부를 사진으로 한정함에 따라 수집 항목의 '첨부 이미지·파일'을 '첨부 사진'으로 정정</li>
            <li><Link to="/privacy/2026-10-05" className="text-red-400 hover:text-red-300">2026년 10월 5일 시행본 보기</Link></li>
            <li>2026년 10월 5일: 처리위탁·국외 이전에 앱 오류 분석(Google Firebase Crashlytics)과 Android 인앱결제 검증(Google Play) 추가, 자동 수집 항목에 앱 오류 정보 추가</li>
            <li><Link to="/privacy/2026-10-01" className="text-red-400 hover:text-red-300">2026년 10월 1일 시행본 보기</Link></li>
          </Ul>
        </Section>

    </LegalPage>
  );
}
